function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  fill: "none",
  d: "M0 0h32v32H0z"
});

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M23.238 18.47c0 4.17-3.4 7.53-7.619 7.53C11.4 26 8 22.64 8 18.47 8 13.055 15.619 6 15.619 6s7.62 7.678 7.62 12.47z",
  fill: "#8E6AF6"
});

var SvgIconSlashActive = function SvgIconSlashActive(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 32 32",
    fill: "none"
  }, props), _ref, _ref2);
};

export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMzIiIGhlaWdodD0iMzIiIHZpZXdCb3g9IjAgMCAzMiAzMiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHJlY3Qgd2lkdGg9IjMyIiBoZWlnaHQ9IjMyIiBmaWxsPSJibGFjayIgZmlsbC1vcGFjaXR5PSIwIi8+CjxwYXRoIGQ9Ik0yMy4yMzgxIDE4LjQ2OTdDMjMuMjM4MSAyMi42Mzk0IDE5LjgzNzkgMjYgMTUuNjE5IDI2QzExLjQwMDIgMjYgOCAyMi42Mzk0IDggMTguNDY5N0M4IDEzLjA1NTMgMTUuNjE5IDYgMTUuNjE5IDZDMTUuNjE5IDYgMjMuMjM4MSAxMy42Nzc2IDIzLjIzODEgMTguNDY5N1oiIGZpbGw9IiM4RTZBRjYiLz4KPC9zdmc+Cg==";
export { SvgIconSlashActive as ReactComponent };